export default class Panel{
	constructor($scope,
				$routeParams,
				panelService,
				$location,
                toastr,
                dataEstadistica,
                calendarioService,
				info,
				clientesService,
				proyectosService,
                jwtHelper
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
		this.dataEstadistica = dataEstadistica;
		this.panelService = panelService;
		this.calendarioService = calendarioService;
		this.info = info;
		this.jwtHelper = jwtHelper;
		this.loading = true;
		this.refreshing = false;
		this.proyectosService = proyectosService;
		this.clientesService = clientesService;
	}

	get() {
		this.panelService.get().then((result) => {
			if (result.status != 200) {
				this.toastr.error('Error', 'Error al obtener estadisticas!', {
                    timeOut: 2000,
                    closeButton: true
                });
			} else {
				if (result.data.success == true) {
					this.scope.tipos = result.data.message;
					console.log(this.scope.tipos)
				} else {
					this.toastr.error('Error', result.data.message, {
	                    timeOut: 2000,
	                    closeButton: true
	                });
				}
				
			}
		}, (rejected) => {
			if (rejected.status != 401){
				this.toastr.error('Error', rejected.data.message, {
					timeOut: 2000,
					closeButton: true
				});
			}
			this.loading = false;
		});


		/* Logica utilizada para saber si se debe desplegar mis otts pendientes */
		this.scope.requiere_mis_otts_no_encontrado = false;  
		//1.- Se obtienen los clientes que posee el usuario
		this.clientesService.getAll().then((resp) => {
			if (resp.data.success == true) {
				if(resp.data.message && resp.data.message.length > 0) {
					console.log(resp.data.message)
					resp.data.message.forEach(element => {
						let filter = {
							"cliente._id": element._id
						};
						filter = JSON.stringify(filter);
						//1.- Se obtienen los proyectos que posee el usuario
						this.proyectosService.getAll({string: filter})
							.then((resp) => {
								if (resp.data.success == true) {
									if(resp.data.message && resp.data.message.length > 0) {
										resp.data.message.forEach(element => {
											//Si existe algun proyecto que si requiere "mis otts pendientes", si se debe desplegar
											if(typeof element.no_requeridos.panel !== 'undefined' 
												&& element.no_requeridos.panel.indexOf("mis_otts_pendientes") >= 0) {
													
											} else {
												this.scope.requiere_mis_otts_no_encontrado = true;
											}
										});
									}
								}
							});
					});
				}
			}
		});

		//Vigila la variable requiere_mis_otts para saber si debe ocultar el cuadro de "mis otts pendientes";
		this.scope.$watch('requiere_mis_otts_no_encontrado', (nuevo) => {
			if(nuevo) {
				if (localStorage.getItem('flag_tecnico') == 'true') {
					let djwt = this.jwtHelper.decodeToken(localStorage.getItem('token'));		
					this.calendarioService.byTecId(djwt._id).then((res) => {
						this.scope.flag_tecnico = (localStorage.getItem('flag_tecnico') == 'true') ? true : false;			
						this.scope.myott = res.data.message;
						this.scope.myottcriterio = "[{\"$match\":{\"tecnicos._id\":\"ObjectId('" + djwt._id + "')\"}}]";
					}, (rejected) => {
						this.toastr.error('Error', rejected, {
							timeOut: 2000,
							closeButton: true
						});
					})
				}
			}
		});
	}

	goTo(tipo, criterio, nombre) {
		if (!this.refreshing) {
			this.dataEstadistica.tipo = tipo;
			this.dataEstadistica.criterio = criterio;
			let special = (nombre == 'Stock critico') ? '1': '0';
			this.location.path('/detalle/' + tipo.toLowerCase() + '/' + special);			
		} else {
			this.toastr.info('Info', 'Esta recargando puede tardar unos segundos...', {
				timeOut: 2000,
				closeButton: true
			});
		}
	}

	refresh() {
		this.refreshing = true;
		this.panelService.refresh().then((result) => {
			if (result.status != 200) {
				this.toastr.error('Error', 'Error al obtener estadisticas!', {
                    timeOut: 2000,
                    closeButton: true
                });
			} else {
				if (result.data.success == true) {
					this.scope.tipos = result.data.message;	
				} else {
					this.toastr.error('Error', result.data.message, {
	                    timeOut: 2000,
	                    closeButton: true
	                });
				}
			}
			this.refreshing = false;
		});
	}
}


// WEBPACK FOOTER //
// ./app/js/controllers/panel/estadisticas.js